import { useEffect } from 'react';
import { toast } from 'sonner';
import { useBootstrap } from './useBootstrap';

export const useVersionCheck = () => {
  const bootstrapState = useBootstrap();

  useEffect(() => {
    if (bootstrapState.status === 'ok') {
      const currentVersion = bootstrapState.manifest.web_version;
      const lastSeenVersion = localStorage.getItem('last_seen_version');

      // Show toast if this is a new version
      if (lastSeenVersion && lastSeenVersion !== currentVersion) {
        toast.success(`Updated to v${currentVersion}`, {
          description: 'Tap to see what\'s new',
          duration: 5000,
          action: {
            label: 'What\'s New',
            onClick: () => {
              window.location.href = '/changelog';
            }
          }
        });
      }

      // Update last seen version
      localStorage.setItem('last_seen_version', currentVersion);
    }
  }, [bootstrapState]);
};
